import { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './typography.module.scss';

export enum TypographyColor {
  main = 'main',
  white = 'white',
  charcoal = 'charcoal',
  dimGray = 'dim-gray',
  carmineRed = 'carmine-red',
  spanishBlue = 'spanish-blue',

  textSecondary = 'text-secondary',
  textTertiary = 'text-tertiary',
  textHint = 'text-hint',
  textHighlight = 'text-highlight',

  titleSecondary = 'title-secondary',
  titleTertiary = 'title-tertiary',
  titlePositionMain = 'title-position-main',
  titlePositionSecondary = 'title-position-secondary',
  titleBenefit = 'title-benefit',
}

export enum TypographyFontFamily {
  main = 'main',
  lato = 'lato',
}

export enum TypographyFontWeight {
  light = 'light',
  regular = 'regular',
  medium = 'medium',
  semiBold = 'semiBold',
  heavy = 'heavy',
  bold = 'bold',
  none = 'none',
}

export enum TypographyType {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
  main = 'main',
  large = 'large',
  medium = 'medium',
  small = 'small',
}

export type TypographyProps = PropsWithChildren & {
  type?: TypographyType;
  font?: TypographyFontFamily;
  color?: TypographyColor;
  weight?: TypographyFontWeight;
  inline?: boolean;
  className?: string;
};

export const Typography = ({
  type = TypographyType.main,
  font = TypographyFontFamily.main,
  color = TypographyColor.main,
  weight = TypographyFontWeight.none,
  inline,
  children,
  className,
}: TypographyProps) => {
  return (
    <div
      className={cn(
        styles.typography,
        className,
        styles[`typography-${type}`],
        styles[`typography-${type}`],
        styles[`typography-weight-${weight}`],
        styles[`typography-font-${font}`],
        styles[`typography-color-${color}`],
        { [styles['typography-inline']]: inline },
      )}
    >
      {children}
    </div>
  );
};
